import React from "react";
import { toZonedTime } from "date-fns-tz";
import { differenceInMinutes } from "date-fns";

import { compareNumbers } from "../../../lib/helpers/compareNumbersAsString";

import { DeviceWorkspaceType } from "../../shared/Forms/DeviceForm/lib/useDeviceFormik";
import { Icon } from "../../shared/Icon/Icon";

export const DeviceStatus = ({
  typeOfWorkspace,
  lastDevicePing,
  timeZone,
  version,
}: {
  typeOfWorkspace: DeviceWorkspaceType;
  lastDevicePing: number | null | undefined;
  timeZone: string;
  version?: string;
}) => {
  if (
    typeOfWorkspace === "room" &&
    version &&
    process.env.REACT_APP_RDX_VERSION &&
    compareNumbers(version, process.env.REACT_APP_RDX_VERSION) < 0
  ) {
    return (
      <div className="offline-device warning-device">
        <span className="text-12 text-secondary lh-12 text-center">
          App update required
        </span>
      </div>
    );
  }

  if (
    typeOfWorkspace === "wayFinder" &&
    version &&
    process.env.REACT_APP_WFX_VERSION &&
    compareNumbers(version, process.env.REACT_APP_WFX_VERSION) < 0
  ) {
    return (
      <div className="offline-device warning-device">
        <span className="text-12 text-secondary lh-12 text-center">
          App update required
        </span>
      </div>
    );
  }

  if (!lastDevicePing) {
    return (
      <div className="offline-device">
        <Icon icon="alert-triangle" />
        <span className="text-12 text-black">Offline</span>
      </div>
    );
  }

  const lastPingDate = toZonedTime(
    new Date(lastDevicePing * 1000),
    timeZone
  );
  const minutesDiff = differenceInMinutes(
    toZonedTime(new Date(), timeZone),
    lastPingDate
  );
  const hoursDiff = minutesDiff / 60;

  switch (true) {
    case hoursDiff < 16.5:
      return <Icon icon="approve-icon" />;
    case hoursDiff <= 24.5:
      return (
        <div className="offline-device warning-device">
          <Icon icon="alert-triangle" />
          <span className="text-12 text-black">Warning</span>
        </div>
      );
    default:
      return (
        <div className="offline-device">
          <Icon icon="alert-triangle" />
          <span className="text-12 text-black">Offline</span>
        </div>
      );
  }
};
